import { Component } from '@angular/core';
import {NgIf} from "@angular/common";
import {Router} from "@angular/router";

@Component({
  selector: 'app-not-found',
	imports: [
	],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.sass'
})
export class NotFoundComponent {
	constructor(private router: Router) {
	}

	toHome(): void {
		this.router.navigate(['home']);
	}
}
